import { Instance, SnapshotOut, types } from 'mobx-state-tree';

/**
 * # ServiceHist
 *
 * ServiceHist을 설명하세요.
 */
export const ServiceHist = types
  .model('ServiceHist')
  // --------------------------------------------------------------------------
  .props({
    serviceHistSid: types.identifierNumber,
    serviceHistDt: types.maybeNull(types.number), // 일자
    gubn: types.maybeNull(types.string), // 구분
    content: types.maybeNull(types.string), // 내용

    useYn: types.optional(types.string, 'Y'),
    delYn: types.optional(types.string, 'N'),

    insertDt: types.optional(types.number, 0),
    updateDt: types.optional(types.number, 0),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model serviceHist --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IServiceHist;
      (Object.keys(newProps) as TServiceHistKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TServiceHist = Instance<typeof ServiceHist>;
type TServiceHistSnapshot = SnapshotOut<typeof ServiceHist>;

export interface IServiceHist extends TServiceHist {}
export type TServiceHistKeys = keyof TServiceHistSnapshot & string;
export interface IServiceHistSnapshot extends TServiceHistSnapshot {}
export const createServiceHist = () => types.optional(ServiceHist, {} as TServiceHist);
